/**
 * Cookie plugin (minimal)
 */
jQuery.cookie = function (b, j, m) {
  if (typeof j != "undefined") {
    m = m || {};
    if (j === null) { j = ""; m.expires = -1; }
    var e = "";
    if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == "number") {
        f = new Date();
        f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000));
      } else { f = m.expires; }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + (m.path) : "";
    var g = m.domain ? "; domain=" + (m.domain) : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie != "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == (b + "=")) {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

Shopify.Products = (function () {
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-viewed-products",
    templateId: "recently-viewed-product-template",
    layout: "slider",
    swipe: true,
    media: "adapt",
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;
  var shownSection = 0;

  function toBool(v) {
    return v === true || v === "true" || v === 1 || v === "1";
  }

  var cookie = {
    configuration: { expires: 90, path: "/", domain: window.location.hostname },
    name: "shopify_recently_viewed",
    write: function (recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(" "), this.configuration);
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null && cookieValue !== undefined && cookieValue !== "") {
        recentlyViewed = cookieValue.split(" ");
      }
      return recentlyViewed;
    },
    destroy: function () {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function () {
    // dacă nu avem nimic real, ascunde întreaga secțiune
    var hasItems = wrapper && wrapper.find(".item, .product-item, .product").length > 0;
    if (!hasItems) {
      var sec = wrapper && wrapper.closest(".halo-recently-viewed-block");
      if (sec && sec.length) sec.remove();
      return;
    }

    wrapper.addClass("recently-viewed-loaded");
    wrapper.show();

    if (config.onComplete) {
      try { config.onComplete(); } catch (e) {}
    }
  };

  function initSlick(productGrid) {
    // slick poate să nu fie încă încărcat (mai ales pe mobil)
    if (!jQuery.fn || typeof jQuery.fn.slick !== "function") return false;

    // reset dacă era deja inițializat
    if (productGrid.hasClass("slick-initialized")) {
      try { productGrid.slick("unslick"); } catch (e) {}
    }

    var itemToShow = parseInt(productGrid.data("item-to-show"), 10) || 1;

    // ✅ booleans corecte (Liquid => string "true"/"false")
    var itemDots = toBool(productGrid.data("item-dots"));
    var itemDotsMb = toBool(productGrid.data("item-dots-mb"));
    var itemArrows = toBool(productGrid.data("item-arrows"));
    var itemArrowsMb = toBool(productGrid.data("item-arrows-mb"));

    var realItems = productGrid.find(".item").length;

    // dacă sunt prea puține items, nu inițializăm slider
    if (realItems <= 1) return true;

    // dacă pe desktop ai itemToShow mare, dar pe mobil vrei tot slider, păstrăm condiția clasică:
    if (realItems <= itemToShow) {
      // totuși pe mobil poți avea 2/3 în view; dacă vrei să forțezi slider oricum, comentează return-ul:
      // return true;
    }

    productGrid.slick({
      mobileFirst: true,
      adaptiveHeight: false,
      vertical: false,
      infinite: true,

      // ✅ touch explicit pentru iOS
      swipe: true,
      touchMove: true,
      draggable: true,

      arrows: itemArrowsMb,
      dots: itemDotsMb,

      // ✅ fallback arrows (dacă window.arrows nu e disponibil încă)
      nextArrow: (window.arrows && window.arrows.icon_next) ? window.arrows.icon_next : '<button type="button" class="slick-next" aria-label="Next">›</button>',
      prevArrow: (window.arrows && window.arrows.icon_prev) ? window.arrows.icon_prev : '<button type="button" class="slick-prev" aria-label="Previous">‹</button>',

      rtl: window.rtl_slick,

      responsive: [
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: itemArrowsMb,
            dots: itemDotsMb,
            swipe: true,
            touchMove: true,
            draggable: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            // ✅ pe mobil ai zis că vrei 2
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: itemArrowsMb,
            dots: itemDotsMb,
            swipe: true,
            touchMove: true,
            draggable: true
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: itemArrowsMb,
            dots: itemDotsMb,
            swipe: true,
            touchMove: true,
            draggable: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: itemArrows,
            dots: itemDots,
            slidesToShow: (itemToShow === 5 ? 4 : itemToShow),
            slidesToScroll: (itemToShow === 5 ? 4 : itemToShow),
            swipe: true,
            touchMove: true,
            draggable: true
          }
        },
        {
          breakpoint: 1599,
          settings: {
            arrows: itemArrows,
            dots: itemDots,
            slidesToShow: itemToShow,
            slidesToScroll: itemToShow,
            swipe: true,
            touchMove: true,
            draggable: true
          }
        }
      ]
    });

    // ✅ iOS Safari reflow + recalcul
    if (productGrid[0]) productGrid[0].offsetHeight;
    try { productGrid.slick("setPosition"); } catch (e) {}

    return true;
  }

  var doAlong = function (wrapperS) {
    var recentlyViewedSection = wrapperS.parents(".halo-recently-viewed-block");

    if (productHandleQueue.length && shownSection < config.howManyToShow) {
      var url = window.routes.root + "/products/" + productHandleQueue[shownSection] + "?view=ajax_section_recently_viewed";

      jQuery.ajax({
        type: "get",
        url: url,
        cache: false,
        success: function (productHtml) {
          if (shownSection === 0) {
            wrapperS.empty();
          }

          wrapperS.append(productHtml);
          shownSection++;
          doAlong(wrapperS);
        },
        error: function () {
          cookie.remove(productHandleQueue[shownSection]);
          shownSection++;
          doAlong(wrapperS);
        }
      });

    } else {
      if (productHandleQueue.length === 0) {
        recentlyViewedSection.remove();
        return;
      }

      // init slider (cu retry scurt dacă slick nu e încă încărcat)
      if (config.layout === "slider") {
        var productGrid = wrapperS;

        var tries = 0;
        (function waitSlick() {
          tries++;
          var ok = initSlick(productGrid);
          if (!ok && tries < 30) {
            setTimeout(waitSlick, 100);
            return;
          }
          finalize();
        })();

      } else {
        finalize();
      }
    }
  };

  return {
    showRecentlyViewed: function (params) {
      params = params || {};
      jQuery.extend(config, params);

      // RESET counts
      shown = 0;
      shownSection = 0;

      productHandleQueue = cookie.read();
      template = config.templateId;
      wrapper = jQuery("#" + config.wrapperId);

      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      if (config.howManyToShow && wrapper.length) {
        doAlong(wrapper);
      } else {
        if (wrapper && wrapper.length) {
          var sec = wrapper.closest(".halo-recently-viewed-block");
          if (sec.length) sec.remove();
        }
      }
    },

    recordRecentlyViewed: function (params) {
      params = params || {};
      jQuery.extend(config, params);

      var recentlyViewed = cookie.read();

      if (window.location.pathname.indexOf("/products/") !== -1) {
        var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        var productHandle = m ? decodeURIComponent(m[1]) : decodeURIComponent(window.location.pathname.split("/products/")[1]);

        var position = jQuery.inArray(productHandle, recentlyViewed);

        if (position === -1) {
          recentlyViewed.unshift(productHandle);
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        cookie.write(recentlyViewed);
      }
    },

    clearList: function () {
      cookie.destroy();
    },

    getConfig: function () {
      return config;
    }
  };
})();
